import { ButtonMantine, Center, Modal, ModalProps, Stack, Text, ThemeIcon } from 'ui';
import { IconCircleCheck } from 'ui/Icons';

interface StudentAddedModalProps extends ModalProps {
  onGoToStudents: () => void;
}

const StudentAddedModal = ({ onGoToStudents, ...props }: StudentAddedModalProps) => {
  return (
    <Modal {...props} withCloseButton={false}>
      <Stack>
        <Center>
          <ThemeIcon size={'64'} c="mint.7" bg="transparent">
            <IconCircleCheck size={64} />
          </ThemeIcon>
        </Center>
        <Stack gap={4}>
          <Text fz="xl" fw={600}>
            Student Added
          </Text>
          <Text fz="sm" c="gray.6">
            You're all set! You’ve linked your student’s account and can now view their fees.
          </Text>
        </Stack>
        <ButtonMantine onClick={onGoToStudents}>Go to Student Fees</ButtonMantine>
      </Stack>
    </Modal>
  );
};

export { StudentAddedModal };
